window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.pagination = `
    <style>
        ul {
            padding: 0;
            margin: 0;
            display: flex;
            list-style: none;
            gap: 0;
        }

        li a, li span {
            font-family: Lato;
            background: #fff;
            border: 1px solid #dad7d7;
            border-radius: 4px;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 4px;
            font-size: 14px;
            letter-spacing: .02em;
            color: #464343;
            text-decoration: none;
        }

        li.previous a {
            background: #fff url(/images/arrow-left-nav.svg) no-repeat center / 7px;
        }

        li.next a {
            background: #fff url(/images/arrow-right-nav.svg) no-repeat center / 7px;
            margin-right: 0;
        }

        li.active span {
            border: 1px solid #e6007e;
            font-weight: 700;
            color: #e6007e;
        }

        li:not(.dots):hover a,li:not(.dots):hover span {
            border: 1px solid #e6007e;
            font-weight: 700;
            color: #e6007e
        }

        li.dots a:hover {
            cursor: default;
            color: inherit
        }
    </style>
    <ul>
        {{#if displayPreviousLink}}
        <li class="previous">
            <a
                hawksearch-page="{{subtract page 1}}"
                rel="prev"
                href="{{pageUrl (subtract page 1)}}"
                title="{{strings.previous}}"
            >
            </a>
        </li>
        {{/if}}

        {{#if (showfirstpagelink @root.page)}}
        <li>
            <a hawksearch-page="1" href="{{pageUrl 1}}" title="{{strings.first}}">
                1
            </a>
        </li>
        <li class="dots"><a href="#" onclick="event.preventDefault(); return false;">&#8230;</a></li>
        {{/if}}

        {{#each pages}}
            {{#if (eq this @root.page)}}
            <li class="active">
                <span>{{this}}</span>
            </li>
            {{else}}
            <li>
                <a hawksearch-page="{{this}}" href="{{pageUrl this}}" class="pagination__page">{{this}}</a>
            </li>
            {{/if}}
        {{/each}}

        {{#if (showlastpagelink @root.page @root.totalPages)}}
        <li class="dots"><a href="#" onclick="event.preventDefault(); return false;">&#8230;</a></li>
        <li>
            <span hawksearch-page="{{totalPages}}" class="link pagination__page pagination__page--last" title="{{strings.last}}">
                {{totalPages}}
            </span>
        </li>
        {{/if}}

        {{#if displayNextLink}}
        <li class="next">
            <a
                hawksearch-page="{{add page 1}}"
                rel="next"
                href="{{pageUrl (add page 1)}}"
                title="{{strings.next}}"
            >
            </a>
        </li>
        {{/if}}
    </ul>
`;
